import { MailWarning } from 'lucide-react'
import { useTranslations } from 'use-intl'

import { Alert, AlertDescription } from '@/components/ui/alert'
import { SITE } from '@/lib/site-config'
import { cn } from '@/lib/utils'

/**
 * Shown on every form confirmation screen: says the email left AND that a mail
 * filter/firewall may swallow it, with a human inbox to fall back on. Corporate
 * mail gateways silently dropped a real lead's email, so a bare "email sent"
 * confirmation leaves the prospect waiting on something that never arrives.
 */
export function EmailFallbackNotice({ className }: { className?: string }) {
  const t = useTranslations('common.emailFallback')

  return (
    <Alert className={cn('text-left', className)}>
      <MailWarning />
      <AlertDescription>
        <p>
          {t.rich('message', {
            email: SITE.leadEmail,
            mail: (chunks) => (
              <a
                href={SITE.leadEmailHref}
                className="font-medium text-primary underline underline-offset-2"
              >
                {chunks}
              </a>
            ),
          })}
        </p>
      </AlertDescription>
    </Alert>
  )
}
